import { Rocket } from 'lucide-react'
import { RestrictionScreen } from './RestrictionScreen'
import { ovText, GEO_STR as S, type CountryOverlayRow } from './geoApi'

/**
 * A11.05 — Bosqichma-bosqich ochish. REAL `/admin/countries` + greenfield
 * rollout overlay (`/admin/geo/rollout` → `{code, stage}`). Bloklangan davlat =
 * yopiq; ochiq davlat overlay stadiyasini (yoki «to'liq») meros oladi.
 */
export function StagedRolloutScreen() {
  return (
    <RestrictionScreen
      screenId="A11.05"
      title={S.rolloutTitle}
      note={S.rolloutNote}
      icon={<Rocket size={28} strokeWidth={1.5} />}
      overlayPath="/admin/geo/rollout"
      overlayKey="rollout"
      overlayField="stage"
      overlayHeader={S.stage}
      renderOverlay={(r: CountryOverlayRow) => {
        if (r.is_blocked) return <span className="text-danger">{S.stageClosed}</span>
        const v = ovText(r, 'stage')
        return v ? <span className="text-primary">{v}</span> : <span className="text-success">{S.stageLive}</span>
      }}
    />
  )
}
